import React from "react";
import { css } from "@emotion/react";
// import { PulseLoader } from 'react-spinners';
import { Hourglass, Oval } from "react-loader-spinner";

const Loader = (props) => {
  const colspan = props.colspan;
  return (
    <tr>
      <td colSpan={colspan} className="center">
        <div
          style={{ display: "flex", justifyContent: "center", padding: "5px" }}
        >
          <Hourglass
            visible={true}
            height="25"
            width="25"
            ariaLabel="hourglass-loading"
            wrapperStyle={{}}
            wrapperClass=""
            colors={["#CF2030e8", "#CF2030"]}
          />
        </div>
      </td>
    </tr>
  );
};

export const OvalLoader = (props) => {
  const color = props.color;
  return (
    <span style={{ display: "flex", justifyContent: "center", padding: "5px" }}>
      <Oval
        visible={true}
        height="35"
        width="35"
        color={color}
        ariaLabel="oval-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </span>
  );
};

export const FullPageLoader = (props) => {
  const visible = props.visible;
  if (visible) {
    return (
      <div
        className="loader-container"
        style={{ display: "flex", justifyContent: "center", padding: "5px" }}
      >
        <Hourglass
          visible={true}
          height="30"
          width="30"
          ariaLabel="hourglass-loading"
          wrapperStyle={{}}
          wrapperClass=""
          colors={["#CF2030e8", "#CF2030"]}
        />
      </div>
    );
  }
};

export default Loader;
